import "../../styles/global.css";
import DownloadableTable from "./DataTable";
import { fetchDemoQuestionAverageByStudent, fetchDemoClickSequenceByStudent, fetchDemoQuizCompletionByStudent, fetchDemoLatestClickByStudent } from "../../api/individualApi";
import { fetchDemoQuestionAverage, fetchAllDemoSubmissionDates } from "../../api/overviewApi";
import React, { useState, useEffect, useMemo } from "react";


const Data = () => {

    const [allDates, setAllDates] = useState([]);
    const [studentQuestionAverage, setStudentQuestionAverage] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log("Fetching all demo submission dates for trend...");
        fetchAllDemoSubmissionDates()
            .then((data) => {
                const timestamps = data.dates.map((d) => new Date(d).getTime());
                const minDate = Math.min(...timestamps);
                const maxDate = Math.max(...timestamps);
                setAllDates([minDate, maxDate]);

                return fetchDemoQuestionAverageByStudent(
                    new Date(minDate).toISOString(),
                    new Date(maxDate).toISOString()
                );
            })
            .then((data) => {
                setStudentQuestionAverage(data?.student_question_stats || []);
            })
            .catch((error) => {
                console.error("Error fetching all demo submission dates:", error);
            });
    }, []);

    useEffect(() => {
        if (studentQuestionAverage.length > 0) {
            console.log("Fetched studentQuestionAverage:", studentQuestionAverage);
        }
    }, [studentQuestionAverage]);

    const reshapedData = useMemo(() => {
        const studentMap = {};
        for (const row of studentQuestionAverage) {
            const name = row.student_name || "Unknown";
            const code = row.group_code || "Unknown";
            const score = parseFloat(row.avg_score) || 0;

            if (!studentMap[name]) {
                studentMap[name] = { 
                    USER_NAME: name,
                    COURSE_DESCRIPTION: "DEMO CLASS",
                };
            }

            studentMap[name][code] = score;
        }
        return Object.values(studentMap);
    }, [studentQuestionAverage]);

    return (
        <div className="wrapper">
            <h1 className="title">DOWNLOAD DATA PREVIEW</h1>
            <DownloadableTable data={reshapedData} />
        </div>
    );
};

export default Data;